import { useCallback, useEffect, useState } from "react";
import { container } from "tsyringe";
import DefaultCastImage from "assets/images/default-avatar.svg";
import LazyImage from "components/elements/LazyImage";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import { useProjectTeamContext } from "components/pages/ProfessionalSpace/contexts/ProjectTeam";
import ProjectTeamCastResponseResource from "common/resources/Project/Config/Team/Cast/ProjectTeamCastResponseResource";
import { useProjectId } from "hooks/useProjectId";
import CastService from "services/projects/CastService";
import { translateISO369 } from "utils/I18nText";
import { formatContributorName } from "utils/UserUtils";
import classes from "./classes.module.scss";

type IProps = {
	cast: ProjectTeamCastResponseResource;
};

const castService = container.resolve(CastService);

export default function CastingCard(props: IProps) {
	const { image } = useCastingInfo(props.cast);

	return (
		<div className={classes["root"]}>
			<LazyImage src={image} alt={translateISO369(props.cast.characterName) ?? ""} className={classes["image"]} />

			<div className={classes["info-container"]}>
				<Typography type="p" size="xlarge" weight="bold">
					{translateISO369(props.cast.characterName)}
				</Typography>

				<div className={classes["info"]}>
					<Typography type="p" size="large" weight="regular">
						{I18n.asset.pages.professional_space.tabs.casting.casting_card.played_by}
					</Typography>
					<Typography type="p" size="large" weight="bold" color="secondary">
						{formatContributorName(props.cast.actor)}
					</Typography>
				</div>
			</div>
		</div>
	);
}

const useCastingInfo = (cast: Pick<ProjectTeamCastResponseResource, "id" | "image">) => {
	const [image, setImage] = useState<string>(DefaultCastImage);
	const { projectId } = useProjectId();
	const { projectTeamId } = useProjectTeamContext();

	const fetchImage = useCallback(() => {
		if (cast.image)
			castService.downloadImage(projectId, projectTeamId, cast.id).then((blob) => {
				if (blob) setImage(URL.createObjectURL(blob));
			});
	}, [cast.id, cast.image, projectId, projectTeamId]);

	useEffect(() => {
		fetchImage();
	}, [fetchImage]);

	return { image };
};
